export default "__VITE_ASSET__CisZUQ2d__"